var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('div',{staticClass:"copyright-inner"},[_c('p',[_vm._v(" Copyright de data gastronoom - All Rights Reserved - "),_c('a',{attrs:{"href":"./privacy-policy/","target":"_blank"}},[_vm._v("Privacy policy")])])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }